import React from 'react';
import PropTypes from 'prop-types';

import withModal from '../../../../../../components/global/modal/withModal';
import { getAsset } from '../../../../../../util/assets';
import Button from '../../../../../../components/global/Button';
import DismissButton from '../../../../../../components/global/DismissButton';

export const VIDEO_GUEST_BOOK_GREETING_MODAL =
  'modal/VIDEO_GUEST_BOOK_GREETING';

const propTypes = {
  onClose: PropTypes.func,
  onRequestClose: PropTypes.func,
  onRecordGreeting: PropTypes.func,
};

const VideoGuestBookGreetingModal = ({
  onRequestClose,
  onRecordGreeting,
  onClose,
}) => {
  return (
    <>
      <DismissButton
        onClick={onRequestClose}
        className="wedding-event-purchase-dismiss"
        width="48px"
      />
      <div className="d-flex">
        <img
          className="m-auto"
          src={getAsset('/wedding-event-icon.png')}
          alt="Record a Greeting Video"
          width="80"
        />
      </div>
      <p className="text-extra-bold text-center text-dark mt-2">
        Welcome to Your Video Guestbook!
      </p>
      <p className="text-center">
        Get started by recording a video greeting for your guests. Then invite
        your guests to your Video Guestbook where they can record their well
        wishes!
      </p>

      <div className="mt-2">
        <Button
          btnBlock
          onClick={() => {
            onClose?.();
            onRecordGreeting();
            onRequestClose();
          }}
        >
          Record my greeting now
        </Button>
        <Button
          btnBlock
          btnStyle="link"
          className="mt-2 text-extra-bold text-center"
          onClick={() => {
            onClose?.();
            onRequestClose();
          }}
          btnSize="xs"
        >
          Will record later
        </Button>
      </div>
    </>
  );
};

VideoGuestBookGreetingModal.propTypes = propTypes;

export default withModal(VideoGuestBookGreetingModal, {
  size: 'sm',
  dismissible: false,
  name: VIDEO_GUEST_BOOK_GREETING_MODAL,
  className: 'video-guestbook-modal',
  overlayClassName: 'video-guestbook-modal-overlay',
});
